import ActionTrackingPage from '@/components/ActionTrackingPage';
import { ALL_ACTION_IDS } from '@/data/actions';

// L'écran « Challenge » affiche toujours les 9 actions du jour. La notion
// d'objectif hebdo personnalisé a été retirée (demande client) — plus de
// sélection de niveau ni de sous-ensemble d'actions.
export default function ChallengeScreen() {
  return <ActionTrackingPage selectedActionIds={ALL_ACTION_IDS} />;
}
